import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { SketchPicker } from 'react-color';

import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import ColorPicker from './ColorPicker.js';
import BorderPicker from './BorderPicker.js';
import PaddingPicker from './PaddingPicker.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class SidebarRowElement extends React.Component {
	constructor(props) {	
		super(props);
		
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleColorChange = this.handleColorChange.bind(this);
		this.handleBorderChange = this.handleBorderChange.bind(this);
		this.onPaddingChange = this.onPaddingChange.bind(this);
	}


    el() {
    	return this.props.builder.components[this.props.id];
    }

    renderSettings() {
    	return <div><SidebarElementSpacing text='Settings' />Dette er en test</div>;
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
    	this.props.setComponentState(this.el().id,{value:v});
    }

    handleColorChange(id,color) {
    	let changes = {};
    	changes[id] = color;
		this.props.setGlobalTypeState('rows',this.props.row.id,changes);
    }

    handleBorderChange(id,border) {
    	let changes = {};
    	changes[id] = border;    	
    	
		this.props.setGlobalTypeState('rows',this.props.row.id,changes);
    }

    onPaddingChange(id,padding) {
		let changes = {};
    	changes[id] = padding;    	
		this.props.setGlobalTypeState('rows',this.props.row.id,changes);
    }

    render() {
    	return(
    		<div className="sidebar text" style={this.props.style}>
    			<SidebarElementHeader handleBackClick={this.handleBackClick} text='Row' />


    			<div className="panel-group panel-group-continuous" id="row-settings" aria-multiselectable="true" role="tablist">

	    				<SidebarSettingAccordion selectedSetting={false} optionKey="outer" parent="row-settings" title="Outer style">
	    					<SidebarElementSetting text="Background color">
								<ColorPicker transparent={true} id='outerBackgroundColor' color={this.props.row.outerBackgroundColor} handleColorChange={this.handleColorChange} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Border top">
								<BorderPicker id='outerBorderTop' handleBorderChange={this.handleBorderChange} data={this.props.row.outerBorderTop} handleColorChange={this.handleColorChange} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Border bottom">
								<BorderPicker id='outerBorderBottom' handleBorderChange={this.handleBorderChange} data={this.props.row.outerBorderBottom} handleColorChange={this.handleColorChange} />
							</SidebarElementSetting>
	    				</SidebarSettingAccordion>

	    				<SidebarSettingAccordion selectedSetting={false} optionKey="inner" parent="row-settings" title="Inner style">
	    					<SidebarElementSetting text="Background color">
								<ColorPicker transparent={true} id='innerBackgroundColor' color={this.props.row.innerBackgroundColor} handleColorChange={this.handleColorChange} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Border top">
								<BorderPicker id='innerBorderTop' handleBorderChange={this.handleBorderChange} data={this.props.row.innerBorderTop} handleColorChange={this.handleColorChange} />
							</SidebarElementSetting>
							
							<SidebarElementSetting text="Border bottom">
								<BorderPicker id='innerBorderBottom' handleBorderChange={this.handleBorderChange} data={this.props.row.innerBorderBottom} handleColorChange={this.handleColorChange} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Padding">
								<PaddingPicker id='innerPadding' handlePaddingChange={this.onPaddingChange} data={this.props.row.innerPadding} />
							</SidebarElementSetting>
	    				</SidebarSettingAccordion>

	   

	    		</div>
    		</div>
		);
    }
}

export default SidebarRowElement;





// WEBPACK FOOTER //
// ./components/builder/SidebarRowElement.js